<template>
    <div id="AppContainer">
        <!-- <nav-header></nav-header> -->
        <!-- <AnnouncementBanner /> -->
        <NavHeader></NavHeader>
        <slot />
        <nav-footer></nav-footer>
        <Footer class="app-footer" hoverColor="green" />
        <NewThetaNutsStrongholdPopup />
    </div>
</template>

<script>
// import navHeader from "../components/navHeader.vue";
import NavHeader from "../components/Header/NavHeader2.vue";
import navFooter from "../components/navFooter.vue";
import Footer from "../components/LandingPage/Footer.vue";
import NewThetaNutsStrongholdPopup from "../components/Popup/NewThetaNutsStrongholdPopup.vue";
import AnnouncementBanner from "../components/AnnouncementBanner.vue";

export default {
    data() {
        return {};
    },
    components: {
    // navHeader,
    NavHeader,
    navFooter,
    Footer,
    NewThetaNutsStrongholdPopup,
    AnnouncementBanner
}
};
</script>
<style lang="scss">
// @import "./resources/sass/app.scss";

#AppContainer {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    position: relative;
    min-height: 100vh;
    display: flex;
    flex-flow: column;
    //margin-top: 60px;
    //height: calc(100vh - 80px );
    background: rgb(20, 21, 21);
    background: radial-gradient(
            58.82% 150.58% at 50% 62.61%,
            rgba(0, 0, 0, 0.2) 0%,
            rgba(0, 13, 23, 0.2) 75%,
            rgba(0, 64, 7, 0.2) 100%
        ),
        linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.1) 26.7%,
            rgba(46, 158, 71, 0.1) 84.52%
        ),
        #171717;
}
body {
    background: rgb(20, 21, 21);
    //background: linear-gradient(180deg, rgba(20,21,21,1) 40%, rgb(26 76 47) 60% ,#171717 100%);
    background: radial-gradient(
            58.82% 150.58% at 50% 62.61%,
            rgba(0, 0, 0, 0.2) 0%,
            rgba(0, 13, 23, 0.2) 75%,
            rgba(0, 64, 7, 0.2) 100%
        ),
        linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.1) 26.7%,
            rgba(46, 158, 71, 0.1) 84.52%
        ),
        #171717;
    height: 100%;
}

.second-wave {
    background: url("/images/bottom_wave.svg") no-repeat;
    background-size: cover;
    position: absolute;
    min-height: 36%;
    width: 100%;
    bottom: 0;
    z-index: 0;
}

.bottom-wave {
    background: url("/images/bottom-leaves.png") no-repeat center bottom;
    position: fixed;
    //background-size: contain;
    //width: -moz-fit-content;
    //width: fit-content;
    background-size: cover;
    width: 100%;
    opacity: 0.2;
    min-height: 100%;
    bottom: 0;
    width: 100vw;
    max-width: 100%; // fixed horizontal overflowed when using 100vw for width
    height: calc(100vw / 1);
    min-height: 61%;
    z-index: 0;

    //outline:1px solid red;

    /*
    
        background-size: cover;
    width: 100vw;
    min-height: 33vh;
    position: absolute;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 29;
    outline: 1px solid red;
    */
}
.app-footer {
    margin-top: 60px;
}
</style>
